// extracted by mini-css-extract-plugin
export default {"popup":"styles_popup__HXtU-","popup_inner":"styles_popup_inner__y73NL","spinner":"styles_spinner__9Vgw5"};